export default __webpack_public_path__ + "static/media/schedule.c687825d.svg";